import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss']
})
export class SubscribeComponent implements OnInit {

  name: string;
  email: string;
  loading: boolean;

  constructor(public router: Router,  private http: HttpClient, public datepipe: DatePipe) { }

  ngOnInit() {
  }

  subscribe() {
      let regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      if (this.name == null) {
          alert("請輸入姓名");
      } else if (this.email == null) {
          alert("請輸入email");
      } else if (regexp.test(this.email) == false) {
          alert("請輸入正確email");
      } else {
          this.loading = true;
          let now = new Date();
          let nowtime = this.datepipe.transform(now, 'yyyy/MM/dd HH:mm:ss');

          this.http.get('https://script.google.com/macros/s/AKfycbxJn9xBTauafwqDfcEjLrmAhAWMsbBZL5WQoS2nYRnf3FQM1PCNkxHEBGpNbIJ2K8g8eg/exec', {
              params: {
                  time: nowtime,
                  name: this.name,
                  mail: this.email
              },
              observe: 'response',
              responseType: 'text',
          }).subscribe(data => {
              this.loading = false;
              if (data.status == 200) {
                  if (data.body == "成功") {
                      alert("已收到您的訂閱，如有進一步更新將會發mail通知您，謝謝！")
                  } else {
                      alert("伺服器錯誤，請稍後再嘗試，謝謝！")
                  }
              } else {
                  alert("伺服器錯誤，請稍後再嘗試，謝謝！")
              }
              window.location.reload();
          });
      }
  }

}
